import { observer } from "mobx-react"
import DataTable from "../../../components/DataTable/DataTable"
import TABLE_COLUMNS from "../const/TABLE_COLUMNS"
import { useContainerInjection } from "../../../hooks/useContainerInjection"
import DataTableRowsSkeleton from "../../../styledComponents/LoadingSkeletons/DataTableRowsSkeleton"
import { useTranslation } from "react-i18next"
import { Invoice } from "../../../../domain/entities/Invoice"
import dayjs from "dayjs"
import { FormField } from "../../../components/Form/FormField"
import { PaymentsViewModel } from "../PaymentsViewModel"

interface PaymentsTableProps {
	data: Invoice[]
	loading?: boolean
	isFetching?: boolean
	onChangePage?: (page: number, pageSize: number, lastPageFetched: number) => void
}

const PaymentsTable = ({ data, loading, isFetching, onChangePage }: PaymentsTableProps) => {
	const viewModel = useContainerInjection<PaymentsViewModel>("PaymentsViewModel")
	const handlePageChange = (page: number, pageSize: number, lastPageFetched: number) => {
		viewModel.setTableConfig({ pageSize })
		onChangePage && onChangePage(page, pageSize, lastPageFetched)
	}
	const { t } = useTranslation("common")
	return (
		<DataTable
			loading={isFetching}
			tableConfig={{
				sort: viewModel.tableConfig.sort,
				pageSize: viewModel.tableConfig.pageSize
			}}
			isFetching={isFetching}
			renderCustomLoadingComponent={() => <DataTableRowsSkeleton size="lg" />}
			onChange={data => {
				data.sorter &&
					viewModel.setTableConfig({ sort: { order: data.sorter.order, field: data.sorter.field } })
			}}
			onChangePage={handlePageChange}
			columns={TABLE_COLUMNS(value => viewModel.setSelectedInvoiceIds(value ? data.map(i => i.id) : []))}
			dataSource={data.map((invoice, idx) => {
				return {
					key: invoice.id,
					id: invoice.id,
					sellerName: invoice.seller?.fiscalName ?? invoice.seller?.sellerName ?? "-",
					invoiceNumber: invoice.invoiceNumber,
					emissionDate: invoice.emissionDate
						? dayjs(invoice.emissionDate.split("T")[0]).format("DD/MM/YYYY")
						: null,
					period: invoice.period,
					sellerPrice: invoice.sellerPrice,
					totalFee: invoice.totalFee,
					total: invoice.total,
					sellerPayment: invoice.sellerPayment,
					sellerPaymentDate: (
						<FormField.DatePicker
							className="mb-0"
							picker="date"
							key={"sellerPaymentDate"}
							value={
								invoice.sellerPaymentDate ? dayjs(invoice.sellerPaymentDate.split("T")[0]) : undefined
							}
							onChange={sellerPaymentDate =>
								viewModel.updateInvoiceDate(invoice.id, {
									sellerPaymentDate: sellerPaymentDate?.format("YYYY-MM-DDT[00:00:00Z]") ?? null
								})
							}
						/>
					),
					feeException: invoice.seller?.feeException ? t("yes") : t("no"),
					collectionAmount: invoice.total,
					collected: invoice.sellerCollectionDate ? t("yes") : t("no"),
					sellerCollectionDate: (
						<FormField.DatePicker
							className="mb-0"
							picker="date"
							key={"sellerCollectionDate"}
							value={
								invoice.sellerCollectionDate
									? dayjs(invoice.sellerCollectionDate.split("T")[0])
									: undefined
							}
							onChange={sellerCollectionDate =>
								viewModel.updateInvoiceDate(invoice.id, {
									sellerCollectionDate: sellerCollectionDate?.format("YYYY-MM-DDT[00:00:00Z]") ?? null
								})
							}
						/>
					)
				}
			})}
		/>
	)
}

export default observer(PaymentsTable)
